import { Box, Icon, Tag, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'

interface WorkedHoursProps {
  contractHoursBaselineEnabled: boolean
  minutes: number
  paidAbsencesMinutes: number
  rangeIncludesToday: boolean
}

const WorkedHours = ({
  contractHoursBaselineEnabled,
  minutes,
  paidAbsencesMinutes,
  rangeIncludesToday,
}: WorkedHoursProps) => {
  return (
    <Box flexDirection="row" gap="s2" flexGrow>
      <Icon.Medium color="grey1000" icon="timer" />
      <Box gap="s2">
        <Box flexDirection="row" gap="s8" alignItems="baseline">
          <Text.Normal color="grey1000" weight="medium">
            {i18n.t('clock_in.bank_of_hours.counters.worked_hours.title')}
          </Text.Normal>
          {rangeIncludesToday && (
            <Text size="100">
              {i18n.t('clock_in.bank_of_hours.counters.until_today').toLowerCase()}
            </Text>
          )}
        </Box>
        <Box flexDirection="row" gap="s8">
          <MinutesToText color="grey1000" value={minutes} size="500" weight="medium" />
          {paidAbsencesMinutes > 0 && contractHoursBaselineEnabled && (
            <Tag type={Tag.Types.grey} size="small">
              <Box flexDirection="row" gap="s4" alignItems="baseline">
                <MinutesToText
                  color="grey1000"
                  value={paidAbsencesMinutes}
                  weight="medium"
                  size="200"
                />
                <Text.Normal color="grey1000" weight="medium" size="200">
                  {i18n
                    .t('clock_in.bank_of_hours.counters.worked_hours.tag_description')
                    .toLowerCase()}
                </Text.Normal>
              </Box>
            </Tag>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default WorkedHours
